import React from "react";
import { useTranslation } from "react-i18next";
import noDataClaim from "../../assets/images/nodataclaim.svg";

const NoDataAvailableState = ({
  subtitle = "",
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`mobileMargin noData noMobileMargin noDataAvailableState ${className}`.trim()}>
      <div>
        <img src={noDataClaim} alt="" />
        <div className="d-flex flex-column align-items-center justify-content-center mt-24 mb-4">
          <h3 className="fs-20 fw-700 colorblur">{t("No data available")}</h3>
          <p className="fs-16">{t(subtitle)}</p>
        </div>
      </div>
    </div>
  );
};

export default NoDataAvailableState;
